"use strict";

var table = {
  25: 19.00,
  30: 26.00,
  35: 26.00,
  40: 33.00,
  45: 33.00,
  50: 40.00,
  55: 47.00,
  60: 47.00,
  65: 54.00,
  70: 54.00,
  75: 63.00,
  80: 70.00,
  85: 70.00,
  90: 77.00,
  95: 77.00,
  100: 85.00,
  105: 92.00,
  110: 92.00,
  115: 99.00,
  120: 99.00,
  125: 110.00,
  130: 117.00,
  135: 117.00,
  140: 124.00,
  145: 124.00,
  150: 130.00,
  155: 137.00,
  160: 137.00,
  165: 144.00,
  170: 144.00,
  175: 153.00,
  180: 160.00,
  185: 160.00,
  190: 167.00,
  195: 167.00,
  200: 175.00,
  205: 182.00,
  210: 182.00,
  215: 189.00,
  220: 189.00,
  225: 196.00,
  230: 196.00,
  235: 199.00,
  240: 202.00,
  245: 205.00,
  250: 208.00,
  255: 211.00,
  260: 214.00,
  265: 217.00,
  270: 220.00,
  275: 223.00,
  280: 226.00,
  285: 229.00,
  290: 232.00,
  295: 235.00,
  300: 238.00,
  305: 241.00,
  310: 244.00,
  315: 247.00,
  320: 250.00,
  325: 253.00,
  330: 256.00,
  335: 259.00,
  340: 262.00,
  345: 265.00,
  350: 268.00,
  355: 271.00,
  360: 274.00,
  365: 277.00,
  370: 280.00,
  375: 283.00,
  380: 286.00,
  385: 289.00,
  390: 292.00,
  395: 295.00,
  400: 298.00,
  405: 301.00,
  410: 304.00,
  415: 307.00,
  420: 310.00,
  425: 313.00,
  430: 316.00,
  435: 319.00,
  440: 322.00,
  445: 325.00,
  450: 328.00,
  455: 331.00,
  460: 334.00,
  465: 337.00,
  470: 340.00,
  475: 343.00,
  480: 346.00,
  485: 349.00,
  490: 352.00,
  495: 355.00,
  500: 358.00,
  505: 361.00,
  510: 364.00,
  515: 367.00,
  520: 370.00,
  525: 373.00,
  530: 376.00,
  535: 379.00,
  540: 382.00,
  545: 385.00,
  550: 388.00,
  555: 391.00,
  560: 394.00,
  565: 397.00,
  570: 400.00,
  575: 403.00,
  580: 406.00,
  585: 409.00,
  590: 412.00,
  595: 415.00,
  600: 418.00,
  605: 421.00,
  610: 424.00,
  615: 427.00,
  620: 430.00,
  625: 433.00,
  630: 436.00,
  635: 439.00,
  640: 442.00,
  645: 445.00,
  650: 448.00,
  655: 451.00,
  660: 454.00,
  665: 457.00,
  670: 460.00,
  675: 463.00,
  680: 466.00,
  685: 469.00,
  690: 472.00,
  695: 475.00,
  700: 478.00,
  705: 481.00,
  710: 484.00,
  715: 487.00,
  720: 490.00,
  725: 493.00,
  730: 496.00,
  735: 499.00,
  740: 502.00,
  745: 505.00,
  750: 508.00,
  755: 511.00,
  760: 514.00,
  765: 517.00,
  770: 520.00,
  775: 523.00,
  780: 526.00,
  785: 529.00,
  790: 532.00,
  795: 535.00,
  800: 538.00,
  805: 541.00,
  810: 544.00,
  815: 547.00,
  820: 550.00,
  825: 553.00,
  830: 556.00,
  835: 559.00,
  840: 562.00,
  845: 565.00,
  850: 568.00,
  855: 571.00,
  860: 574.00,
  865: 577.00,
  870: 580.00,
  875: 583.00,
  880: 586.00,
  885: 589.00,
  890: 592.00,
  895: 595.00,
  900: 598.00
};

module.exports = function (accumulator, order, product, component) {
  var quantity = component.quantity;
  var addition = table[quantity] || 0;

  if (product.paper_type.match(/double thick/i)) {
    return (parseFloat(accumulator, 10) || 0) + addition;
  }

  return accumulator;
};